export const getZeroInDecimal = (value: number) => {
    return value - (value - Math.floor(value));
};
